import { Icon, IconName, Typography } from '@themenu/design-system'
import Link from 'next/link'
import { PERMISSIONS } from '../../../../../constants'

import { useRouter } from 'next/router'
import type { HTMLAttributeAnchorTarget } from 'react'

export type MenuItemProps = {
  href?: string
  id: string
  action?: () => void
  target?: HTMLAttributeAnchorTarget
  label: string
  icon?: string
  testId?: string
  active?: boolean
  permission: PERMISSIONS[]
}

export const MenuButton = ({
  href,
  id,
  label,
  icon = undefined,
  testId,
  target = '_self',
  action,
  ...props
}: MenuItemProps) => {
  const { route } = useRouter()

  if (action) {
    return (
      <li {...props}>
        <span
          className="flex items-center gap-12 px-[25px] py-8 hover:bg-background-default rounded-8"
          onClick={action}
          title={label}
          data-testid={testId}
          id={id}
        >
          {icon && <Icon name={icon as IconName} />}
          <Typography variant="footnote">{label}</Typography>
        </span>
      </li>
    )
  }

  const active = route === href || route.startsWith(href ?? '')

  return (
    <li className="mb-4" {...props}>
      <Link
        href={href as string}
        title={label}
        data-testid={testId}
        target={target}
        id={id}
        className={`flex items-center gap-12 px-[25px] py-8 hover:bg-background-default rounded-8
          ${active ? 'bg-background-default' : ''}`}
      >
        {icon && <Icon name={icon as IconName} />}
        <Typography
          variant="footnote"
          className={active ? 'text-content-primary' : ''}
        >
          {label}
        </Typography>
      </Link>
    </li>
  )
}
